export const cultureRegion: Record<string, string> = {
  EN: 'en-US',
  FR: 'fr',
  PT: 'pt-BR',
};

export const cultureRegionMapper = (culture: string) => {
  return cultureRegion[culture] || cultureRegion['EN'];
};
